import { httpInterceptor } from '../http-interceptor';

export class AirCompressorsService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllAirCompressorsNew',
    SAVE_NEW: 'Machine/saveNewAirCompressor',
    UPDATE: 'Machine/saveNewAirCompressor',
    DELETE: 'Machine/deleteAirCompressor',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateAirCompressorsMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByAirCompressorId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveAirCompressorMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllAirCompressorByAsstNo',
    GET_SAFETY_CHECKLIST_BY_AIR_COMPRESSOR: 'Machine/airCompressorSafetyChecklistByAirCompressor',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateAirCompressorSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteAirCompressorSafetyChecklist'
  };

  static async getAllAirCompressors(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewAirCompressor(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updateAirCompressor(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteAirCompressor(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async saveAirCompressorsMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByAirCompressorId(airCompressorId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${airCompressorId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(maintenanceData) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, maintenanceData);
  }

  static async getAllAirCompressorByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getAirCompressorSafetyChecklistByAirCompressor(airCompressorId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_AIR_COMPRESSOR}/${airCompressorId}`,
    );
  }

  static async createAirCompressorSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteAirCompressorSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
